import React from "react";

import {rpAppLink} from "@pg-mono/rp-routes";

import {Country} from "../../../../region/types/Country";
import {RegionType} from "../../../../region/types/RegionType";
import {OfferLocationLinksItem} from "../../../atoms/OfferListLocationLinksItem";
import {offerUrlBuilder} from "../../../helpers/friendly_offer_list/offer_url_builder";
import {getOfferTypeNamePluralCapital, getPropertiesCountFieldName} from "../../../helpers/OfferType";
import {OfferType} from "../../../types/OfferType";
import {offerPlural} from "../../../utils/offer_plural";

export interface IProps {
    nearbyRegions: INearbyRegion[];
    offerType: OfferType | null;
    country?: number | null;
}

export interface INearbyRegion {
    name: string;
    slug: string;
    id: number;
    stats: {
        properties_all_count_for_sale: number;
        properties_flats_count_for_sale: number;
        properties_houses_count_for_sale: number;
        properties_commercials_count_for_sale: number;
    } | null;
    type: RegionType;
}

export const OfferListLocationLinksNearbyRegions: React.FC<IProps> = (props) => {
    const {nearbyRegions, offerType, country} = props;
    return (
        <>
            {nearbyRegions.map((region) => {
                const amount = region.stats && region.stats[getPropertiesCountFieldName(offerType)];
                if (amount && amount > 0) {
                    const {friendlySlug, countrySlug} = offerUrlBuilder({type: offerType, region: region.slug, country: country});
                    let link = rpAppLink.offer.listFriendly({friendlySlug: friendlySlug});
                    if (country == Country.SPAIN) {
                        link = rpAppLink.offer.listFriendlyAbroad({
                            friendlySlug: friendlySlug,
                            country: countrySlug,
                            abroadRegionSlug: region.slug
                        });
                    }
                    const linkText = `${
                        offerType
                            ? offerType !== OfferType.COMMERCIAL
                                ? `${getOfferTypeNamePluralCapital(offerType)} na sprzedaż`
                                : getOfferTypeNamePluralCapital(offerType)
                            : "Nieruchomości"
                    } ${region.name} (${amount} ${offerPlural(amount)})`;
                    return <OfferLocationLinksItem linkText={linkText} url={link} key={region.id} />;
                }
            })}
        </>
    );
};
import React from "react";

import {rpAppLink} from "@pg-mono/rp-routes";

import {Country} from "../../../../region/types/Country";
import {RegionType} from "../../../../region/types/RegionType";
import {OfferLocationLinksItem} from "../../../atoms/OfferListLocationLinksItem";
import {offerUrlBuilder} from "../../../helpers/friendly_offer_list/offer_url_builder";
import {getOfferTypeNamePluralCapital, getPropertiesCountFieldName} from "../../../helpers/OfferType";
import {OfferType} from "../../../types/OfferType";
import {offerPlural} from "../../../utils/offer_plural";

export interface IProps {
    nearbyRegions: INearbyRegion[];
    offerType: OfferType | null;
    country?: number | null;
}

export interface INearbyRegion {
    name: string;
    slug: string;
    id: number;
    stats: {
        properties_all_count_for_sale: number;
        properties_flats_count_for_sale: number;
        properties_houses_count_for_sale: number;
        properties_commercials_count_for_sale: number;
    } | null;
    type: RegionType;
}

export const OfferListLocationLinksNearbyRegions: React.FC<IProps> = (props) => {
    const {nearbyRegions, offerType, country} = props;
    return (
        <>
            {nearbyRegions.map((region) => {
                const amount = region.stats && region.stats[getPropertiesCountFieldName(offerType)];
                if (amount && amount > 0) {
                    const {friendlySlug, countrySlug} = offerUrlBuilder({type: offerType, region: region.slug, country: country});
                    let link = rpAppLink.offer.listFriendly({friendlySlug: friendlySlug});
                    if (country == Country.SPAIN) {
                        link = rpAppLink.offer.listFriendlyAbroad({
                            friendlySlug: friendlySlug,
                            country: countrySlug,
                            abroadRegionSlug: region.slug
                        });
                    }
                    const linkText = `${
                        offerType
                            ? offerType !== OfferType.COMMERCIAL
                                ? `${getOfferTypeNamePluralCapital(offerType)} na sprzedaż`
                                : getOfferTypeNamePluralCapital(offerType)
                            : "Nieruchomości"
                    } ${region.name} (${amount} ${offerPlural(amount)})`;
                    return <OfferLocationLinksItem linkText={linkText} url={link} key={region.id} />;
                }
            })}
        </>
    );
};
